<template>
  <v-data-table
    :headers="headers"
    :items="items"
    sort-by="name"
    :search="search"
    class="elevation-0 general-table main-top-margin"
    :loading="isLoading"
    @click:row="editItem"
    :loading-text="$t('GLOBAL-LOADING-PLEASE_WAIT')"
  >
    <template v-slot:header.name="{ header }">
      <span class="warehouse-list__header-txt"><lang t="WAREHOUSES-TBL-HEADER-NAME"></lang></span>
    </template>

    <template v-slot:header.itemCount="{ header }">
      <span class="warehouse-list__header-txt"><lang t="WAREHOUSES-TBL-HEADER-ARTICLES"></lang></span>
    </template>

    <template v-slot:header.productionsystems="{ header }">
      <span class="warehouse-list__header-txt"><lang t="WAREHOUSES-TBL-HEADER-PRODUCTION_SYSTEMS"></lang></span>
    </template>

    <template v-slot:header.client="{ header }">
      <span class="warehouse-list__header-txt"><lang t="WAREHOUSES-TBL-HEADER-CLIENT"></lang></span>
    </template>

    <template v-slot:top>
      <div class="d-flex align-center flex-wrap py-2 mb-3">
        <v-text-field
          clearable
          class="general-table__search general-table__search--short"
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          :label="$t('GLOBAL-DO_SEARCH')"
          solo
          flat
          dense
          hide-details
        />

        <v-spacer></v-spacer>
        <Button type="outside-label" icon="mdi-plus" :label="$t('WAREHOUSES-NEW_WAREHOUSE')" @click="addWarehouse()" />
      </div>

      <v-dialog v-model="dialog" max-width="640px" :persistent="false">
        <v-card>
          <v-card-title>
            <span class="title1"><lang t="WAREHOUSES-NEW_WAREHOUSE"></lang></span>
          </v-card-title>

          <v-card-text>
            <v-form ref="form" v-model="isFormValid">
              <v-row>
                <!-- Mandant -->
                <v-col cols="12" v-if="currentUser.role == 'su'">
                  <v-select
                    required
                    dense
                    :items="mandates"
                    v-model="editedItem.mandate_id"
                    item-value="id"
                    item-text="name"
                    :label="$t('WAREHOUSES-WAREHOUSE-CLIENT')"
                  ></v-select>
                </v-col>

                <!-- Name -->
                <v-col cols="12">
                  <v-text-field
                    required
                    :rules="[(v) => !!v || $t('GLOBAL-FORM-FIELD_REQUIRED')]"
                    dense
                    v-model="editedItem.name"
                    :label="$t('WAREHOUSES-WAREHOUSE-NAME')"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="close" :disabled="isSaving">{{ $t("GLOBAL-BTN-CANCEL") }}</v-btn>
            <v-btn elevation="0" class="general-action-btn" :disabled="!isFormValid" @click="save" :loading="isSaving">{{
              $t("GLOBAL-BTN-SAVE")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template v-slot:item.itemCount="{ item }">
      <display-number :number="item.itemCount" />
    </template>

    <template v-slot:item.productionsystems="{ item }">
      <v-chip-group column>
        <simpleChip
          center
          readonly
          short
          :small="true"
          defaultIcon=""
          v-for="tag in item.productionsystems"
          :value="tag.id"
          :name="tag.name"
          :key="tag.id"
        />
      </v-chip-group>
    </template>

    <template v-slot:footer.page-text="props" v-if="(items.length > 0)">
      <display-number :number="props.pageStart" />-<display-number :number="props.pageStop" /> {{ $t("of") }}
      <display-number :number="items.length" />
    </template>

    <template v-slot:item.actions="{ item }">
      <v-icon small class="pa-1" color="grey darken-2" @click.stop="editItem(item)">mdi-pencil</v-icon>
      <v-icon small class="pa-1" color="secondary" @click.stop.prevent="deleteItem(item)" :disabled="!item.isDeleteable"
        >mdi-trash-can-outline</v-icon
      >
    </template>

    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template>
  </v-data-table>
</template>

<script>
import Button from "../../components/ui-elements/Button.vue";
import SimpleChip from "../../components/ui-elements/SimpleChip.vue";
import DisplayNumber from "../../components/DisplayNumber.vue";
export default {
  name: "WarehouseIndex",
  components: {
    Button,
    SimpleChip,
    DisplayNumber,
  },
  data() {
    var self = this;

    return {
      isSaving: false,
      isLoading: true,
      dialog: false,
      dialogType: null,

      isFormValid: false,

      search: "",

      mandates: null,

      headers: [
        { text: "Name", align: "start", value: "name", sortable: true, class: "general-table__th--4" },
        { text: "Client", value: "client", sortable: false, class: "general-table__th--4" },
        { text: "Article", value: "itemCount", sortable: false, class: "general-table__th--4" },
        { text: "Automatisierungslösungen", value: "productionsystems", sortable: false, class: "general-table__th--4" },
        { text: "", value: "actions", sortable: false, align: "end", width: "80px" },
      ],

      items: [],

      editedIndex: -1,
      editedItem: {
        name: "",
        mandate_id: null,
      },
      defaultItem: {
        name: "",
        mandate_id: null,
      },
    };
  },

  computed: {
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.isLoading = true;

      return this.axios.get("warehouses").then((res) => {
    
        this.items = res.data;
        this.isLoading = false;
      });
    },

    addWarehouse() {
      this.dialog = false;

      this.editedItem = JSON.parse(JSON.stringify(this.defaultItem));

      if (this.mandates == null) {
        this.axios.get("mandates").then((res) => {
          this.mandates = res.data;
          this.dialog = true;
        });
      } else {
        this.dialog = true;
      }
    },

    editItem(item) {
      this.$router.push({ name: "warehouse", params: { tab: "items", id: item.id } });
    },

    deleteItem(item) {
      this.$confirm(this.$t("GLOBAL-CONFIRMATION-DELETE-MSG", { NAME: item.name }), {
        title: this.$t("GLOBAL-CONFIRMATION-DELETE-TITLE"),
        buttonTrueText: this.$t("GLOBAL-CONFIRMATION-DELETE-YES"),
        buttonFalseText: this.$t("GLOBAL-CONFIRMATION-DELETE-CANCEL"),
      }).then((res) => {
        if (res) {
          this.axios.delete("warehouses/" + item.id).then((res) => {
            this.initialize();
            this.$store.dispatch("setSnackbar", { text: this.$t("GLOBAL-SUCCESSFULLY_DELETED") });
          });
        }
      });
    },
    close() {
      this.dialog = false;
      this.isSaving = false;
      this.$refs.form.resetValidation();

      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (!this.$refs.form.validate()) {
        return false;
      }

      this.isSaving = true;
      let snackMsg = "";

      let saveObj = {
        mandate_id: this.editedItem.mandate_id,
        name: this.editedItem.name,
      };

      this.axios
        .post("warehouses", saveObj)
        .then((res) => {
          this.isSaving = false;
          this.$router.push({ name: "warehouse", params: { id: res.data.id } });
        })
        .catch((err) => {});
    },
  },
};
</script>

<style lang="scss">
.v-chip {
  &.v-size--small {
    .v-icon {
      font-size: 18px;
    }
  }
}

.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > td:not(.v-data-table__mobile-row),
.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > th:not(.v-data-table__mobile-row) {
  border-bottom: 1px solid #cdcdcd !important;
}

.warehouse-list {
  & table {
    border: 1px solid #cdcdcd !important;
  }
  &::v-deep v-data-footer {
    justify-content: center;
  }
  &__header-txt {
    text-transform: uppercase;
    color: #878889;
  }
}
</style>
